var activityEvents=["mousedown","mousemove","keydown","scroll","touchstart","click","keypress","touchmove"];
    activityEvents.forEach(function(e){window.addEventListener(e,functionCustomJS,!1)});
let flag = false;
function functionCustomJS() {
  if (flag == false) {
      flag = true;
      var script_loaded=!1;function loadJSscripts(){setTimeout(function(){if(!script_loaded){script_loaded=!0;var t=document.getElementsByTagName("script");for(i=0;i<t.length;i++)null!==t[i].getAttribute("data-src")&&(t[i].setAttribute("src",t[i].getAttribute("data-src")),delete t[i].dataset.src);var e=document.getElementsByTagName("link");for(i=0;i<e.length;i++)null!==e[i].getAttribute("data-href")&&(e[i].setAttribute("href",e[i].getAttribute("data-href")),delete e[i].dataset.href);setTimeout(function(){document.dispatchEvent(new CustomEvent("StartAsyncLoading")),document.dispatchEvent(new CustomEvent("StartKernelLoading"))},400)}},9e3)}function loadJSscriptsNow(){if(!script_loaded){script_loaded=!0;var t=document.getElementsByTagName("script");for(i=0;i<t.length;i++)null!==t[i].getAttribute("data-src")&&(t[i].setAttribute("src",t[i].getAttribute("data-src")),delete t[i].dataset.src);var e=document.getElementsByTagName("link");for(i=0;i<e.length;i++)null!==e[i].getAttribute("data-href")&&(e[i].setAttribute("href",e[i].getAttribute("data-href")),delete e[i].dataset.href);setTimeout(function(){document.dispatchEvent(new CustomEvent("StartAsyncLoading")),document.dispatchEvent(new CustomEvent("StartKernelLoading"))},400)}}var activityEvents=["mousedown","mousemove","keydown","scroll","touchstart","click","keypress","touchmove"];activityEvents.forEach(function(t){window.addEventListener(t,loadJSscriptsNow,!1)}),document.addEventListener("load",loadJSscripts,!1),document.addEventListener("onload",loadJSscripts,!1),null!=window.addEventListener?window.addEventListener("load",loadJSscripts,!1):null!=window.attachEvent?window.attachEvent("onload",loadJSscripts):window.onload=loadJSscripts;
  }
}

/* EC-STAGE1-ZEROCOMMERCE-20260808b
   Emergency kill for Shopify IndexController page_cache serving legacy quiz commerce.
   essencraft.js is present on cached homepage HTML and is not content-addressed by v=. */
(function () {
  if (window.__ecStage1ZeroCommerce) return;
  window.__ecStage1ZeroCommerce = '20260808b';
  var SEL = [
    '[data-ec-quiz-commerce]',
    '.ec-quiz__commerce',
    '.ec-quiz__sub-card',
    '.ec-quiz__onetime',
    '[data-ec-sub-card]',
    '[data-ec-onetime]',
    '[data-ec-quiz-subscribe]',
    '[data-ec-quiz-onetime]',
    '[data-ec-commerce-error]',
    '[data-ec-sub-today]',
    '[data-ec-sub-recurring]',
    '[data-ec-onetime-price]',
    '[data-ec-sub-title]',
    '[data-ec-sub-benefits]',
    '[data-ec-testing-actions] [data-ec-quiz-save-offer]'
  ].join(',');
  var GUIDE = {
    resin: {
      batch_testing: { url: '/pages/shilajit-resin-testing', commercialProduct: 'resin' },
      sensory: { url: '/pages/shilajit-resin-sensory', commercialProduct: 'resin' },
      usage: { url: '/pages/shilajit-resin-usage', commercialProduct: 'resin' }
    },
    testing_first: {
      heavy_metals: { url: '/pages/shilajit-lab-results', commercialProduct: null },
      batch_testing: { url: '/pages/testing-transparency-hub', commercialProduct: null },
      organic_source: { url: '/pages/testing-transparency-hub', commercialProduct: null },
      process: { url: '/pages/testing-transparency-hub', commercialProduct: null }
    },
    capsules: {
      batch_testing: { url: '/products/shilajit-extract?view=capsules-v7-demo#ec-testing-batch', commercialProduct: 'capsules' }
    },
    atlas_x: {
      batch_testing: { url: '/products/atlas-x-10-in-1-masculinity-maximiser?view=atlas-v7-demo', commercialProduct: 'atlas_x' }
    }
  };
  function injectCss() {
    if (document.getElementById('ec-stage1-zero-commerce-css')) return;
    var s = document.createElement('style');
    s.id = 'ec-stage1-zero-commerce-css';
    s.textContent = SEL + '{display:none!important;visibility:hidden!important;pointer-events:none!important;position:absolute!important;width:0!important;height:0!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;margin:0!important;padding:0!important;border:0!important;font-size:0!important}';
    (document.head || document.documentElement).appendChild(s);
  }
  function purge() {
    try {
      document.querySelectorAll(SEL).forEach(function (el) {
        try { el.remove(); } catch (e) {
          el.hidden = true;
          el.setAttribute('hidden', '');
          el.style.cssText = 'display:none!important';
          el.innerHTML = '';
        }
      });
    } catch (e) {}
  }
  function patchConfig() {
    var el = document.querySelector('script[data-ec-quiz-config]');
    if (!el) return;
    try {
      var cfg = JSON.parse(el.textContent);
      cfg.destinations = cfg.destinations || {};
      Object.keys(GUIDE).forEach(function (route) {
        cfg.destinations[route] = cfg.destinations[route] || {};
        Object.keys(GUIDE[route]).forEach(function (concern) {
          cfg.destinations[route][concern] = Object.assign({}, cfg.destinations[route][concern] || {}, GUIDE[route][concern]);
        });
      });
      el.textContent = JSON.stringify(cfg);
      document.querySelectorAll('[data-ec-home-quiz]').forEach(function (root) {
        if (root.__ecHomeQuiz) {
          root.__ecHomeQuiz.config = cfg;
          if (root.__ecHomeQuiz.purgeStage1Commerce) root.__ecHomeQuiz.purgeStage1Commerce();
          if (root.__ecHomeQuiz.renderCommerce) {
            root.__ecHomeQuiz.renderCommerce = function () { if (this.purgeStage1Commerce) this.purgeStage1Commerce(); };
          }
        }
      });
    } catch (e) {}
  }
  function boot() {
    injectCss();
    purge();
    patchConfig();
  }
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  try {
    new MutationObserver(function () { purge(); }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
  setInterval(boot, 1500);
})();
